import React from 'react';
import { Navigate, Outlet, RouteObject } from 'react-router';

import { permissions } from './permissions';
import { PermissionGuard } from '~/core/PermissionGuard';
import { Route as LoanRoute } from '~/core/routes/loans/[loanId]/_index';
import { Route as LoansRoute } from '~/core/routes/loans/_index';

// Exports
export const Router: RouteObject = {
  element: (
    <PermissionGuard
      permissions={permissions}
      fallback={<Navigate to="/" replace />}
    >
      <Outlet />
    </PermissionGuard>
  ),
  // Relative to /loans/*
  children: [
    { index: true, element: <LoansRoute /> },
    { path: ':loanId', element: <LoanRoute /> },
    { path: '*', element: <Navigate to="./" replace /> },
  ],
};
